/* eslint-disable */
export default {
  _basket_menu_tween: 'basket-menu-tween',
  _bird_jump_fly_tween: 'bird-jump-fly-tween',
  _click: 'click',
  _cup_stacking_title_fall: 'cup-stacking-title-fall',
  _cup: 'cup',
  _cups_leave_tween: 'cups-leave-tween',
  _incorrect_letter: 'incorrect-letter',
  _title_bird_singing: 'title-bird-singing',
  _whoosh: 'whoosh',
}